import { BasketIcon } from './BasketIcon';

/**
 * author: Google
 * id 4E334FE9-DF93-469A-B7D7-AC88BBF25D84
 * name basket
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/basket.svg
 * tags
 * - Shopping 
 */
export const ShoppingBasketIcon = BasketIcon;
export default ShoppingBasketIcon